import service from "@/utils/request"

export function getJdGoodsDetailById(data) {
    return service({
        url: '/jdData/getGoodsDetail',
        method: 'get',
        params: data
    })
}